export default {
    // set up global error handling/logging for application
    InitAxios(api) {
        // interceptor for error handling globally
        api.interceptors.response.use(
            (response) => response,
            async (error) => {
                if (error.response && error.response.status === 401 && !error.response._retry) {
                    // on the first 401 refresh jwt and retry the failed call
                    const response = await api.get("Authentication/Refresh");
                    const newJWT = response.data;
                    localStorage.setItem("jwt", newJWT);
                    api.defaults.headers.common["Authorization"] = "Bearer " + newJWT;
                    const originalRequest = error.config;
                    originalRequest.headers["Authorization"] = "Bearer " + newJWT;
                    originalRequest._retry = true;
                    return api(originalRequest);
                } else if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                    // on the 2nd 401 (check retry flag) clear the token and redirect to login
                    localStorage.removeItem("jwt");
                    // redirect to login page
                    // var currentpage = encodeURIComponent(window.location.pathname + window.location.search);
                    const loginpage = "/login"; // + ?r=currentpage;
                    // if we get an authentication error, send user to the login page (unless we are already there)
                    if (window.location.pathname != loginpage) {
                        window.location.replace(loginpage);
                    }
                } else if (error.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                } else if (error.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser
                    // and an instance of http.ClientRequest in node.js
                    console.log(error.request);
                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log("Error", error.message);
                }
                return Promise.reject(error);
            },
        );
    },
    // InitVue(app) {
    //     app.config.errorHandler = (err, vm, info) => {
    //         // `info` is a Vue-specific error info, e.g. which lifecycle hook
    //         // the error was found in. Only available in 2.2.0+
    //         ErrorLog(`Vue Error at [${info}] > ${err}`);
    //     };
    // },
};
// // private function to log client errors to server
// function ErrorLog(msg) {
//     // new instance to avoid global error handler (since we're already here)
//     let instance = axios.create();
//     instance.post(`${this.$apiroot}log/error`, JSON.stringify(msg));
// }
